import { classNames } from "helpers/ClassNameHelper";
import React from "react";
import { Row, TableBodyPropGetter, TableBodyProps } from "react-table";
import { TableType } from "./Table";

interface Props {
    getTableBodyProps: (propGetter?: TableBodyPropGetter<object>) => TableBodyProps;
    rows: Row<object>[];
    prepareRow: (row: Row<object>) => void;
    tableType: TableType;
    fontSize?: number;
}

export const TableBody: React.FC<Props> = ({
    getTableBodyProps,
    rows,
    prepareRow,
    tableType,
    fontSize,
}) => {
    return (
        <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
                prepareRow(row);
                return (
                    <tr className="table-row" {...row.getRowProps()}>
                        {row.cells.map((cell: any) => {
                            return (
                                <td
                                    className={classNames(
                                        `${tableType}-data`,
                                        cell.column.className
                                    )}
                                    {...cell.getCellProps()}
                                >
                                    <span
                                        style={{ fontSize: fontSize ? `${fontSize}%` : undefined }}
                                    >
                                        {cell.render("Cell")}
                                    </span>
                                </td>
                            );
                        })}
                    </tr>
                );
            })}
        </tbody>
    );
};
